import ViewModuleIcon from '@mui/icons-material/ViewModule'
import ViewListIcon from '@mui/icons-material/ViewList'
import { useAppSelector } from "../_hooks/useAppSelector"
import type { ProductLayoutType } from "../../UserData/_stores/UserPrefsStore"
import { useCallback } from "react"
import type { MouseEvent } from "react"
import { useAppDispatch } from "../_hooks/useAppDispatch"
import { SaveUserPrefs } from "../../UserData/_actions/UserDataActions"
import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material'

const SearchBarToggleButton = styled(ToggleButton)({
  background: 'none',
  border: 0,
  borderRadius: 0
})

const SearchBarToggleButtonGroup = styled(ToggleButtonGroup)(({theme}) => ({
  alignSelf: 'stretch',
  marginRight: theme.spacing(1.5),

  [`${SearchBarToggleButton}`]: {
    '&:not(:first-of-type)': {
      border: 0,
      margin: 0
    }
  }
})) 

interface Props {
  value?: ProductLayoutType
  onChange: (value: ProductLayoutType) => void
}

export default function LayoutSelect(props: Props) {
  const dispatch = useAppDispatch()
  const userLayout = useAppSelector(state => state.get('userData').get('prefs').get('accountProductsLayout'))

  const onLayoutChange = useCallback((e: MouseEvent<HTMLElement>, value?: ProductLayoutType) => {
    if (!value) return

    props.onChange(value)

    if (value === userLayout) {
      return
    }

    const fd = new FormData()
    fd.append('accountProductsLayout', value)
    dispatch(SaveUserPrefs(fd, true))
  }, [dispatch, props.onChange, userLayout])

  return <SearchBarToggleButtonGroup
    exclusive
    value={props.value}
    onChange={onLayoutChange}
  >
    <SearchBarToggleButton value="grid">
      <ViewModuleIcon />
    </SearchBarToggleButton>
    <SearchBarToggleButton value="list">
      <ViewListIcon />
    </SearchBarToggleButton>
  </SearchBarToggleButtonGroup>
}
